import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

const PAYMENT_TERM_CORE_FIELDS = gql`
  fragment PaymentTermCoreFields on PaymentTerm {
    id
    name
    days
    hiddenAt
  }
`;

export const PAYMENT_TERM_FIELDS = gql`
  ${PAYMENT_TERM_CORE_FIELDS}
  fragment PaymentTermFields on PaymentTerm {
    ...PaymentTermCoreFields
  }
`;

export const PAYMENT_TERM = gql`
  ${PAYMENT_TERM_FIELDS}
  query PaymentTerm($id: ID!) {
    paymentTerm(id: $id) {
      ...PaymentTermFields
    }
  }
`;

export const PAYMENT_TERMS = gql`
  ${PAYMENT_TERM_FIELDS}
  query PaymentTerms {
    paymentTerms {
      ...PaymentTermFields
    }
  }
`;

const PAYMENT_TERM_ARGUMENTS = `
  $name: String!
  $days: Int!
`;

const PAYMENT_TERM_VARIABLES = `
  name: $name
  days: $days
`;

export const CREATE_PAYMENT_TERM = gql`
  ${PAYMENT_TERM_CORE_FIELDS}
  mutation CreatePaymentTerm (
    ${PAYMENT_TERM_ARGUMENTS}
  ) {
    createPaymentTerm (
      ${PAYMENT_TERM_VARIABLES}
    ) {
      paymentTerm {
        ...PaymentTermCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UPDATE_PAYMENT_TERM = gql`
  ${PAYMENT_TERM_CORE_FIELDS}
  mutation UpdatePaymentTerm (
    $id: ID!
    ${PAYMENT_TERM_ARGUMENTS}
  ) {
    updatePaymentTerm (
      id: $id
      ${PAYMENT_TERM_VARIABLES}
    ) {
      paymentTerm {
        ...PaymentTermCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const HIDE_PAYMENT_TERM = gql`
  ${PAYMENT_TERM_CORE_FIELDS}
  mutation HidePaymentTerm ($id: ID!) {
    hidePaymentTerm (id: $id) {
      paymentTerm {
        ...PaymentTermCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UNHIDE_PAYMENT_TERM = gql`
  ${PAYMENT_TERM_CORE_FIELDS}
  mutation UnhidePaymentTerm ($id: ID!) {
    unhidePaymentTerm (id: $id) {
      paymentTerm {
        ...PaymentTermCoreFields
      }
      ${ERRORS}
    }
  }
`;
